/**
 * 接口路径配置：
 */
const base ={	
	host:URLCONFIG.BASE_URL,
	login:'/login/login',//登录接口
	uploadurl:URLCONFIG.BASE_URL+'/ajax/upload',//上传地址需要单独设置
    config:'/system/config/index', //系统设置获取
    config:'/system/config/edit', //系统设置保存	
    menu:'/system/menu/index',//菜单信息获取
	menupid:'/system.menu/getPid',
	menuedit:'/system.menu/edit',
	menuadd:'/system.menu/add',	
}

export default base;
